import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { Avatar, AvatarFallback, AvatarImage } from '@monksflow/monks-ui';

import { brandIconUrl } from '@/shared/utils/brandDomains';

interface BrandIdentityProps {
  advertiser: string;
  /** Null when no domain could be resolved without guessing; the colour swatch stands in. */
  domain: string | null;
  /** The brand's chart series colour, tying the chip to its line and bar segments. */
  color: string;
  className?: string;
}

export const BrandIdentity = ({ advertiser, domain, color, className }: BrandIdentityProps) => {
  const { t } = useTranslation('analysis');

  return (
    <Avatar className={clsx('size-6 rounded-full', className)}>
      {domain && (
        <AvatarImage
          src={brandIconUrl(domain)}
          alt={t('analysisResult.brandIdentity.logoAlt', { brand: advertiser })}
          referrerPolicy="no-referrer"
        />
      )}
      <AvatarFallback
        data-testid="brand-identity-swatch"
        className="border-0"
        style={{ backgroundColor: color }}
      />
    </Avatar>
  );
};
